export default {
  postHaluoCard(params) {
    return this.http(
      'Bingo',
      'post',
      '/api/v1/knowledge_course_vouchers',
      params
    );
  },
  postElemeCard(params) {
    return this.http('Columbus', 'post', '/fapi/v1/activities/orders', params);
  }
};
